<template>
  <input
    type="number"
    class="form-control"
    @input="onInput"
    :value="value"
    :min="0"
  />
</template>
<script>
export default {
  name: "BaseNumberInput",
  props: {
    value: Number,
    maxValue: Number,
  },
  methods: {
    onInput(event) {
      const newValue = parseInt(event.target.value);
      const clampedValue = Math.min(newValue, this.maxValue);
      this.$emit("input", newValue);
      this.$nextTick(() => {
        this.$emit("input", clampedValue);
      });
    },
  },
};
</script>